var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnloadBefore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 380,
    height: 160,
    viewBox: "0 0 380 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8420",
    "data-name": "Rectangle 8420",
    width: 380,
    height: 160,
    transform: "translate(726 418)",
    fill: "#efefef"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "unload_your_card_before_blocking_illustration",
    "data-name": "unload your card before blocking illustration",
    transform: "translate(-726 -418)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35261",
    "data-name": "Group 35261",
    transform: "translate(-2.925 -6.462)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28080",
    "data-name": "Group 28080",
    transform: "translate(847.453 510.445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28079",
    "data-name": "Group 28079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28058",
    "data-name": "Group 28058",
    transform: "translate(24.442 16.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31153",
    "data-name": "Path 31153",
    d: "M-4700.191-6640.06c-.121,0-.244,0-.352.011v-.675a.578.578,0,0,0,.03.181.175.175,0,0,0,.021.082.749.749,0,0,0,.082.163c.009.008.009.021.02.021a.439.439,0,0,0,.105.119A.483.483,0,0,0-4700.191-6640.06Z",
    transform: "translate(4700.543 6640.724)",
    fill: "#1952a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28059",
    "data-name": "Group 28059",
    transform: "translate(24.439 16.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31154",
    "data-name": "Path 31154",
    d: "M-4700.293-6640.16a.445.445,0,0,0,.1.1c-.121,0-.244,0-.353.01v-.675a.536.536,0,0,0,.032.181.171.171,0,0,0,.02.082.764.764,0,0,0,.083.163c.009.01.009.021.02.021A.368.368,0,0,0-4700.293-6640.16Z",
    transform: "translate(4700.546 6640.724)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31155",
    "data-name": "Path 31155",
    d: "M-4699.919-6640.092a.652.652,0,0,0,0,.2l-.089-.05a1.654,1.654,0,0,1-.2-.15A1.917,1.917,0,0,1-4699.919-6640.092Z",
    transform: "translate(4700.565 6640.758)",
    fill: "#f79d50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28060",
    "data-name": "Group 28060",
    transform: "translate(24.442 16.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31156",
    "data-name": "Path 31156",
    d: "M-4700.191-6640.06c-.121,0-.244,0-.352.011v-.675a.578.578,0,0,0,.03.181.175.175,0,0,0,.021.082.749.749,0,0,0,.082.163c.009.008.009.021.02.021a.439.439,0,0,0,.105.119A.483.483,0,0,0-4700.191-6640.06Z",
    transform: "translate(4700.543 6640.724)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28061",
    "data-name": "Group 28061",
    transform: "translate(45.522 19.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31157",
    "data-name": "Path 31157",
    d: "M-4680.433-6637.794v.14a.238.238,0,0,0-.082-.02.187.187,0,0,0-.082-.021l.082-.05C-4680.487-6637.761-4680.459-6637.776-4680.433-6637.794Z",
    transform: "translate(4680.596 6637.794)",
    fill: "#1952a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28062",
    "data-name": "Group 28062",
    transform: "translate(45.522 19.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31158",
    "data-name": "Path 31158",
    d: "M-4680.433-6637.794v.14a.238.238,0,0,0-.082-.02.187.187,0,0,0-.082-.021l.082-.05C-4680.487-6637.761-4680.459-6637.776-4680.433-6637.794Z",
    transform: "translate(4680.596 6637.794)",
    fill: "#f79d50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28063",
    "data-name": "Group 28063",
    transform: "translate(45.6 19.936)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31159",
    "data-name": "Path 31159",
    d: "M-4680.44-6637.794v.14a.225.225,0,0,0-.082-.02v-.07A.607.607,0,0,0-4680.44-6637.794Z",
    transform: "translate(4680.522 6637.794)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28064",
    "data-name": "Group 28064",
    transform: "translate(45.524 19.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31160",
    "data-name": "Path 31160",
    d: "M-4680.513-6637.746v.069a.3.3,0,0,0-.082-.02Z",
    transform: "translate(4680.594 6637.746)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28065",
    "data-name": "Group 28065",
    transform: "translate(24.43 11.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31161",
    "data-name": "Path 31161",
    d: "M-4678.736-6638.157v.012a.823.823,0,0,1-.041.211v.011a1.6,1.6,0,0,1-.106.2.029.029,0,0,1-.011.02.929.929,0,0,1-.162.171,1.748,1.748,0,0,1-.244.18.639.639,0,0,1-.082.05l-.082.049h-.009l-1.97,1.123-4.86,2.784a3.141,3.141,0,0,1-2.883.041l-8.678-5.083-2.041-1.2a.632.632,0,0,1,0-.2h-.292a.47.47,0,0,1-.1-.1.391.391,0,0,1-.105-.122c-.009,0-.009-.008-.021-.019a.839.839,0,0,1-.082-.164.2.2,0,0,1-.02-.082.614.614,0,0,1-.03-.181,1.028,1.028,0,0,1,.643-.854l4.418-2.536,2.494-1.428a3.194,3.194,0,0,1,2.892-.03l4.227,2.481,6.579,3.848A1,1,0,0,1-4678.736-6638.157Z",
    transform: "translate(4700.554 6645.632)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31162",
    "data-name": "Path 31162",
    d: "M-4699.919-6640.093a.652.652,0,0,0,0,.2l-.089-.051a1.345,1.345,0,0,1-.2-.15A2.4,2.4,0,0,1-4699.919-6640.093Z",
    transform: "translate(4700.574 6645.946)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28066",
    "data-name": "Group 28066",
    transform: "translate(17.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31163",
    "data-name": "Path 31163",
    d: "M-4634.171-6632.231l-24.58,3.849a29.7,29.7,0,0,0-9.033-7.653,54.656,54.656,0,0,0-17.742-6.147l-4.227-2.481a3.192,3.192,0,0,0-2.893.03l-2.492,1.425a76.247,76.247,0,0,0-11.531.423l21.657-12.576a11.827,11.827,0,0,1,10.768,0Z",
    transform: "translate(4706.668 6656.658)",
    fill: "#1952a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28067",
    "data-name": "Group 28067",
    transform: "translate(65.904 32.361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31164",
    "data-name": "Path 31164",
    d: "M-4661.3-6626.037v.082c0-.012,0-.021-.01-.021v-.051Z",
    transform: "translate(4661.31 6626.037)",
    fill: "#0f1c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28068",
    "data-name": "Group 28068",
    transform: "translate(47.736 28.266)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31165",
    "data-name": "Path 31165",
    d: "M-4656.815-6620.5a.181.181,0,0,0,0-.069v-.071c-.012-.051-.012-.091-.021-.14v-.07c-.009-.092-.009-.181-.019-.261v-.011c-.021-.191-.04-.371-.061-.562-.01-.04-.01-.082-.021-.13l-.03-.262a2.275,2.275,0,0,0-.051-.271c-.02-.141-.051-.281-.081-.422-.011-.051-.021-.106-.029-.163s-.031-.151-.052-.231c-.02-.106-.049-.22-.081-.331-.02-.09-.05-.181-.069-.271-.011-.021-.011-.039-.021-.061-.021-.07-.041-.151-.061-.231s-.051-.151-.07-.23a2.975,2.975,0,0,0-.105-.312v-.021a.027.027,0,0,1-.011-.019c-.01-.039-.03-.091-.04-.132a.477.477,0,0,0-.05-.13,1.42,1.42,0,0,0-.081-.232c-.01-.009-.01-.03-.021-.039-.011-.03-.02-.051-.031-.082a.712.712,0,0,0-.05-.141.659.659,0,0,0-.039-.129l-.011-.013c0-.008,0-.008-.01-.008-.04-.105-.081-.2-.12-.3l-.061-.153a1.106,1.106,0,0,0-.07-.15v-.008c-.09-.2-.18-.413-.281-.614v-.01l-.011-.01-.15-.3-.151-.3-.01-.012c-.01-.008-.01-.019-.021-.03-.06-.12-.131-.232-.19-.34a2.478,2.478,0,0,1-.12-.232.009.009,0,0,1-.01-.009h0c-.05-.091-.1-.172-.151-.251l-.089-.152a.061.061,0,0,0-.021-.041.072.072,0,0,1-.019-.041.085.085,0,0,1-.032-.059.112.112,0,0,0-.029-.04.113.113,0,0,0-.03-.042v-.01l-.01-.009-.01-.012a.155.155,0,0,0-.041-.069.168.168,0,0,0-.04-.062v-.012c-.011-.009-.021-.029-.031-.04a.012.012,0,0,1-.009-.012h0c-.082-.129-.164-.242-.252-.371l-.011-.009c0-.011,0-.011-.01-.021s-.009-.02-.02-.031a.7.7,0,0,0-.081-.1c0-.01-.012-.01-.012-.021a.173.173,0,0,0-.04-.061c0-.011-.01-.021-.021-.031s-.021-.009-.021-.019a.054.054,0,0,0-.029-.041c-.009-.01-.021-.03-.029-.04s0-.009-.01-.02c-.04-.06-.091-.131-.141-.191a.037.037,0,0,0-.021-.028.449.449,0,0,1-.03-.052l-3.324.522-2.672.423-12.144,26.309,1.485.853,3.405,1.967c1.348-.613,2.632-1.286,3.849-1.987,6.327-3.646,10.437-8.219,12.1-13.07.009-.029.019-.061.029-.089a.649.649,0,0,0,.03-.082c.051-.15.105-.311.141-.461a.751.751,0,0,0,.041-.132,2.489,2.489,0,0,0,.07-.252.033.033,0,0,0,.01-.029c0-.009.01-.03.01-.042s.01-.019.01-.028a.248.248,0,0,0,.02-.083c0-.021.01-.049.01-.071s.011-.009.011-.021a.042.042,0,0,1,.01-.021.051.051,0,0,0,.009-.04v-.02c.01-.051.031-.106.042-.163.04-.2.081-.4.119-.593.03-.138.051-.281.081-.421l.01-.011c-.01-.009-.01-.009,0-.021-.01-.02,0-.038.01-.06-.01-.009,0-.02,0-.029a.17.17,0,0,0,.009-.07c0-.02.01-.029.01-.05a.111.111,0,0,0,.012-.061v-.152c.039-.22.061-.422.091-.643,0-.028.01-.059.01-.089v-.071c.02-.191.029-.371.04-.563.011-.121.011-.26.011-.372v-.192A5.756,5.756,0,0,0-4656.815-6620.5Zm-3.506-5.234c0-.012,0-.021-.012-.021v-.05l.012-.009Z",
    transform: "translate(4678.501 6629.912)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31166",
    "data-name": "Path 31166",
    d: "M-4661.3-6626.037v.082c0-.012,0-.021-.01-.021v-.051Z",
    transform: "translate(4679.478 6630.132)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28069",
    "data-name": "Group 28069",
    transform: "translate(65.886 24.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31167",
    "data-name": "Path 31167",
    d: "M-4660.879-6629.275v.009l-.01-.009c0-.012,0-.012-.01-.021h.01C-4660.889-6629.286-4660.879-6629.286-4660.879-6629.275Z",
    transform: "translate(4661.351 6633.787)",
    fill: "#1952a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31168",
    "data-name": "Path 31168",
    d: "M-4660.518-6628.732v.01l-.009-.01a.168.168,0,0,0-.041-.07A.165.165,0,0,1-4660.518-6628.732Z",
    transform: "translate(4661.37 6633.815)",
    fill: "#1952a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31169",
    "data-name": "Path 31169",
    d: "M-4660.509-6628.727v.01l-.011-.01Z",
    transform: "translate(4661.372 6633.819)",
    fill: "#1952a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31170",
    "data-name": "Path 31170",
    d: "M-4659.8-6627.474c-.009-.007-.009-.019-.02-.029-.061-.121-.131-.233-.19-.34-.044-.076-.083-.153-.121-.231a.014.014,0,0,1-.01-.011h0c-.05-.09-.1-.17-.149-.25l-.09-.153a.081.081,0,0,0-.021-.04.077.077,0,0,1-.021-.039.093.093,0,0,1-.031-.062l.021.02c.041.082.089.163.14.245.03.039.051.089.081.129a1.487,1.487,0,0,1,.106.171c.083.141.171.291.246.442A.231.231,0,0,1-4659.8-6627.474Z",
    transform: "translate(4661.376 6633.825)",
    fill: "#1952a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31171",
    "data-name": "Path 31171",
    d: "M-4659.2-6626.3l-.021.009h-.011v-.009c-.089-.2-.18-.413-.281-.614v-.008l-.01-.013c-.051-.1-.1-.2-.15-.3l-.15-.3a2.815,2.815,0,0,1,.163.282,9.711,9.711,0,0,1,.431.883.109.109,0,0,1,.02.049C-4659.209-6626.3-4659.2-6626.3-4659.2-6626.3Z",
    transform: "translate(4661.412 6633.887)",
    fill: "#1952a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31172",
    "data-name": "Path 31172",
    d: "M-4636.747-6633.545l-24.549,3.9a.479.479,0,0,0-.03-.05Z",
    transform: "translate(4661.326 6633.545)",
    fill: "#1952a1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28070",
    "data-name": "Group 28070",
    transform: "translate(66.337 28.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31173",
    "data-name": "Path 31173",
    d: "M-4660.879-6629.277v.01l-.011-.01c0-.011,0-.011-.01-.02h.01C-4660.889-6629.286-4660.879-6629.286-4660.879-6629.277Z",
    transform: "translate(4660.9 6629.296)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31174",
    "data-name": "Path 31174",
    d: "M-4660.519-6628.736v.009l-.009-.009Z",
    transform: "translate(4660.921 6629.329)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31175",
    "data-name": "Path 31175",
    d: "M-4660.51-6628.727v.011l-.011-.011Z",
    transform: "translate(4660.922 6629.329)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31176",
    "data-name": "Path 31176",
    d: "M-4659.8-6627.485c-.011-.008-.011-.019-.021-.029-.062-.121-.131-.231-.19-.341-.043-.075-.084-.154-.12-.232a.011.011,0,0,1-.01-.01h0c-.05-.09-.105-.17-.15-.251l-.091-.15a.194.194,0,0,0,.04.048.178.178,0,0,1,.051.071c.03.039.051.089.081.13a1.463,1.463,0,0,1,.106.169c.082.142.171.291.245.442A.238.238,0,0,1-4659.8-6627.485Z",
    transform: "translate(4660.929 6629.341)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31177",
    "data-name": "Path 31177",
    d: "M-4658.027-6622.216a2.316,2.316,0,0,0-.051-.271c-.02-.142-.051-.283-.081-.424l-.03-.161c-.02-.07-.03-.152-.051-.232a3.271,3.271,0,0,0-.081-.331c-.021-.091-.05-.182-.07-.271-.011-.021-.011-.04-.02-.062-.021-.069-.042-.15-.061-.23s-.05-.152-.069-.232c-.032-.1-.06-.2-.106-.312v-.02a.024.024,0,0,1-.01-.02c-.01-.04-.03-.09-.041-.132a.471.471,0,0,0-.051-.13,1.644,1.644,0,0,0-.081-.231c-.011-.009-.011-.03-.02-.04-.011-.029-.021-.05-.032-.081a.775.775,0,0,0-.049-.14.721.721,0,0,0-.04-.132l-.01-.012c0-.009,0-.009-.011-.009-.04-.106-.081-.2-.12-.3l-.06-.152a1.071,1.071,0,0,0-.071-.151v-.01c-.09-.2-.18-.411-.282-.614v-.008l-.009-.01-.151-.3-.15-.3a2.251,2.251,0,0,1,.163.283,9.563,9.563,0,0,1,.432.882c.01.021.02.03.02.05s.01.011.01.021a.758.758,0,0,1,.041.106c.082.17.15.352.219.528a7.533,7.533,0,0,1,.272.74c.02.07.04.14.06.2.061.171.106.352.163.522.009.05.03.105.04.151.082.3.164.6.221.895.04.181.081.362.105.528a.15.15,0,0,1,.01.09.2.2,0,0,1,.021.105A1.656,1.656,0,0,1-4658.027-6622.216Z",
    transform: "translate(4660.961 6629.396)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31178",
    "data-name": "Path 31178",
    d: "M-4658.013-6621.626v.082c-.021-.191-.04-.371-.061-.562-.009-.041-.009-.082-.019-.13l-.03-.262a.356.356,0,0,1,.02.106c0,.03.011.06.011.088a.117.117,0,0,1,.01.052,1.326,1.326,0,0,1,.02.19C-4658.046-6621.92-4658.025-6621.768-4658.013-6621.626Z",
    transform: "translate(4661.058 6629.683)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31179",
    "data-name": "Path 31179",
    d: "M-4657.962-6620.171v.352a.018.018,0,0,1,0,.025h0v.151c-.01.106-.01.2-.02.3s-.021.192-.03.28c-.01.107-.021.22-.041.332a.389.389,0,0,0-.01.111c-.011.089-.021.18-.031.271a.01.01,0,0,1-.011-.011h0v-.04h-.009v-.04c.04-.22.06-.423.089-.643,0-.029.01-.059.01-.09v-.069c.02-.192.029-.373.04-.562C-4657.962-6619.92-4657.962-6620.062-4657.962-6620.171Z",
    transform: "translate(4661.058 6629.814)",
    fill: "#0f1c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28071",
    "data-name": "Group 28071",
    transform: "translate(66.347 28.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31180",
    "data-name": "Path 31180",
    d: "M-4660.881-6629.274v.01l-.01-.01Z",
    transform: "translate(4660.891 6629.274)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31181",
    "data-name": "Path 31181",
    d: "M-4659.194-6626.2a.944.944,0,0,0-.071-.151h.011Z",
    transform: "translate(4660.982 6629.44)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31182",
    "data-name": "Path 31182",
    d: "M-4658.893-6625.417c-.009-.029-.02-.048-.03-.082a.9.9,0,0,0-.051-.141A1.078,1.078,0,0,1-4658.893-6625.417Z",
    transform: "translate(4661 6629.48)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31183",
    "data-name": "Path 31183",
    d: "M-4658.744-6625.028a.466.466,0,0,0-.05-.131,1.652,1.652,0,0,0-.082-.232c.029.069.05.14.082.211,0,.01.01.01.01.02C-4658.773-6625.119-4658.755-6625.062-4658.744-6625.028Z",
    transform: "translate(4661.004 6629.495)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31184",
    "data-name": "Path 31184",
    d: "M-4658.54-6624.361c-.02-.071-.05-.151-.07-.23l.008.009C-4658.581-6624.5-4658.558-6624.432-4658.54-6624.361Z",
    transform: "translate(4661.02 6629.541)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31185",
    "data-name": "Path 31185",
    d: "M-4658.167-6622.775v.04c-.02-.139-.051-.281-.082-.423C-4658.218-6623.026-4658.2-6622.9-4658.167-6622.775Z",
    transform: "translate(4661.04 6629.622)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31186",
    "data-name": "Path 31186",
    d: "M-4657.963-6620.171v.352a.018.018,0,0,1,0,.025h0v.151c-.01.106-.01.2-.022.3s-.02.192-.027.28c-.012.111-.022.22-.041.332a.389.389,0,0,0-.01.111c-.011.089-.021.18-.032.271.032.251.051.5.071.753-.021-.231-.051-.473-.083-.7v-.021h-.01v-.12c.041-.22.061-.424.09-.643,0-.029.01-.06.01-.091v-.068c.02-.192.029-.373.04-.564A3.5,3.5,0,0,0-4657.963-6620.171Z",
    transform: "translate(4661.048 6629.792)",
    fill: "#f79d50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28072",
    "data-name": "Group 28072",
    transform: "translate(68.649 38.558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31187",
    "data-name": "Path 31187",
    d: "M-4658.461-6616.656l-.06.245v.009c-.06.192-.121.392-.191.594.051-.152.1-.311.141-.461a.631.631,0,0,0,.04-.133C-4658.5-6616.493-4658.482-6616.575-4658.461-6616.656Z",
    transform: "translate(4658.712 6620.372)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31188",
    "data-name": "Path 31188",
    d: "M-4658.38-6616.988s-.011,0-.011.009v-.009Z",
    transform: "translate(4658.73 6620.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31189",
    "data-name": "Path 31189",
    d: "M-4658.254-6617.541c-.01.039-.02.07-.031.111a.9.9,0,0,0,.02-.106Z",
    transform: "translate(4658.736 6620.322)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31190",
    "data-name": "Path 31190",
    d: "M-4658.146-6618.11a2.26,2.26,0,0,0-.051.29c-.011.071-.029.14-.041.211-.006.028-.012.056-.02.082a.861.861,0,0,0,.02-.152c.03-.138.05-.279.081-.421Z",
    transform: "translate(4658.738 6620.29)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31191",
    "data-name": "Path 31191",
    d: "M-4658.022-6617.674c-.02-.233-.05-.472-.082-.7-.011.09-.03.179-.039.261a.03.03,0,0,0-.01.021c-.011-.021,0-.039.01-.062-.01-.01,0-.02,0-.029a.2.2,0,0,0,.01-.07c0-.021.01-.031.01-.051a.128.128,0,0,0,.01-.06v-.062l.011-.01v-.039a.108.108,0,0,0,.011-.051v-.04a.029.029,0,0,0,.01-.019v-.041a.043.043,0,0,0,.01-.031.052.052,0,0,1,.01-.039c-.01.087-.02.18-.031.271C-4658.061-6618.172-4658.042-6617.925-4658.022-6617.674Z",
    transform: "translate(4658.743 6620.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31192",
    "data-name": "Path 31192",
    d: "M-4657.965-6620.172v.352a.019.019,0,0,1,0,.027h0v.151c-.01.105-.01.2-.02.3s-.02.191-.029.28c-.011.107-.021.22-.041.331.009-.119.019-.229.029-.352,0-.028.01-.059.01-.089v-.07c.02-.19.029-.373.04-.562C-4657.965-6619.921-4657.965-6620.062-4657.965-6620.172Z",
    transform: "translate(4658.749 6620.172)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28073",
    "data-name": "Group 28073",
    transform: "translate(52.638 24.437)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31193",
    "data-name": "Path 31193",
    d: "M-4609.126-6616.168v.01a3.139,3.139,0,0,1-.031.413,3.028,3.028,0,0,1-.105.412,4.308,4.308,0,0,1-2.069,2.261l-37.41,21.736a11.842,11.842,0,0,1-10.768,0l-10.617-6.129-3.736-2.161c1.346-.612,2.632-1.285,3.846-1.987,6.329-3.646,10.437-8.22,12.1-13.071.01-.03.018-.06.031-.09s.02-.049.029-.081c.071-.2.131-.4.192-.593v-.009c.019-.082.04-.163.06-.244a.037.037,0,0,0,.01-.029c0-.013.01-.029.01-.04s.011-.021.011-.031a.284.284,0,0,0,.02-.082c0-.02.009-.049.009-.07s.01-.009.01-.021a.043.043,0,0,1,.01-.02.071.071,0,0,0,.01-.04v-.011a.01.01,0,0,1,.01-.01h0v-.01l.03-.152c.03-.106.05-.2.071-.3v-.009c.01-.041.021-.071.03-.106v-.021c.008-.026.014-.052.02-.081.01-.071.03-.14.042-.21a2.553,2.553,0,0,1,.05-.291c-.011-.011-.011-.011,0-.021a.033.033,0,0,1,.01-.02c.01-.082.03-.171.04-.26.03.23.061.471.082.7-.021-.252-.042-.5-.07-.751l.028-.272a.449.449,0,0,1,.009-.105c.02-.106.031-.221.042-.333.01-.089.019-.191.029-.281s.01-.2.021-.3v-.15a.019.019,0,0,0,0-.025h0c.009-.192.02-.372.02-.563a5.183,5.183,0,0,0-.03-.674c.01-.021,0-.05,0-.07v-.07a3.75,3.75,0,0,0-.04-.563,4.7,4.7,0,0,0-.071-.634.138.138,0,0,0-.009-.051c0-.03-.011-.059-.011-.09a.35.35,0,0,0-.02-.1,1.624,1.624,0,0,0-.03-.211.209.209,0,0,0-.02-.105.144.144,0,0,0-.01-.09c-.021-.172-.06-.352-.1-.528-.061-.29-.141-.594-.222-.9-.01-.048-.03-.1-.042-.15-.05-.171-.1-.352-.163-.523-.021-.061-.042-.132-.06-.2-.082-.252-.172-.5-.271-.74-.07-.182-.141-.36-.222-.529-.008-.031-.02-.071-.03-.106h-.009c0-.01,0-.01-.01-.02s-.01-.031-.021-.051a9.636,9.636,0,0,0-.431-.883,2.56,2.56,0,0,0-.163-.282l-.009-.009a.238.238,0,0,0-.071-.152c-.069-.15-.163-.3-.244-.44a1.623,1.623,0,0,0-.106-.172c-.031-.04-.049-.091-.082-.132-.049-.082-.1-.162-.14-.245l-.021-.019a.152.152,0,0,0-.029-.039.142.142,0,0,0-.03-.04v-.021h-.01v-.01a.178.178,0,0,0-.05-.069.212.212,0,0,0-.041-.061v-.01c-.01-.009-.021-.03-.03-.04a.009.009,0,0,1-.009-.009h0c-.082-.132-.164-.244-.252-.372h0c0-.01-.009-.01-.009-.02h-.01a.059.059,0,0,0-.02-.031.8.8,0,0,0-.082-.105c0-.009-.009-.009-.009-.02a.217.217,0,0,0-.042-.062c0-.009-.011-.021-.02-.031s-.021-.01-.021-.019a.055.055,0,0,0-.029-.042c-.009-.01-.021-.029-.03-.042s0-.009-.009-.019c-.042-.061-.093-.132-.142-.192,0-.01-.009-.02-.019-.029l24.549-3.9,24.669,14.232a6.8,6.8,0,0,1,1.075.784c.1.093.192.189.281.291a1.554,1.554,0,0,1,.171.192,3.307,3.307,0,0,1,.529.915,2.908,2.908,0,0,1,.131.414A2.571,2.571,0,0,1-4609.126-6616.168Z",
    transform: "translate(4673.863 6633.534)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31194",
    "data-name": "Path 31194",
    d: "M-4658.255-6617.541c-.01.039-.02.071-.03.106.01-.03.01-.062.02-.106Z",
    transform: "translate(4674.748 6634.443)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31195",
    "data-name": "Path 31195",
    d: "M-4658.148-6618.108a2.224,2.224,0,0,0-.051.289c.01-.089.031-.181.04-.281Z",
    transform: "translate(4674.752 6634.411)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31196",
    "data-name": "Path 31196",
    d: "M-4658.021-6617.674c-.021-.232-.051-.472-.083-.7-.011.09-.03.18-.039.261a.044.044,0,0,0-.01.021c-.011-.021,0-.04.01-.062-.01-.01,0-.019,0-.029a.2.2,0,0,0,.01-.07c0-.021.01-.028.01-.05a.117.117,0,0,0,.01-.061v-.03h.011c0-.011.011-.02,0-.04v-.04a.1.1,0,0,0,.011-.05.067.067,0,0,0,.01-.06.182.182,0,0,0,.01-.07.059.059,0,0,1,.01-.042c-.01.091-.02.181-.031.271C-4658.061-6618.176-4658.042-6617.924-4658.021-6617.674Z",
    transform: "translate(4674.754 6634.376)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31197",
    "data-name": "Path 31197",
    d: "M-4657.97-6619.81v.15c-.01.106-.01.2-.021.3C-4657.98-6619.509-4657.97-6619.66-4657.97-6619.81Z",
    transform: "translate(4674.765 6634.314)",
    fill: "#0f1c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28074",
    "data-name": "Group 28074",
    transform: "translate(0 26.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31198",
    "data-name": "Path 31198",
    d: "M-4606.3-6616.14l-.011,3.968a3.782,3.782,0,0,1-2.208,3.1l-37.411,21.737a11.9,11.9,0,0,1-10.768,0l-14.353-8.287-4.892-2.822-45.482-26.268a3.793,3.793,0,0,1-2.25-3.132l.009-4.1a2.791,2.791,0,0,0,.141.845,2.946,2.946,0,0,0,.423.824,3.87,3.87,0,0,0,.316.392,5.448,5.448,0,0,0,1.366,1.074l45.483,26.267,1.486.854,3.405,1.968,3.737,2.159,10.616,6.129a11.839,11.839,0,0,0,10.768,0l37.41-21.736a4.314,4.314,0,0,0,2.07-2.262,2.693,2.693,0,0,0,.106-.413A1.439,1.439,0,0,0-4606.3-6616.14Z",
    transform: "translate(4723.672 6631.939)",
    fill: "#f5f8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31199",
    "data-name": "Path 31199",
    d: "M-4612.6-6617.093v.111a1.585,1.585,0,0,1-.028.3A2.97,2.97,0,0,0-4612.6-6617.093Z",
    transform: "translate(4729.978 6632.782)",
    fill: "#0f1c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28075",
    "data-name": "Group 28075",
    transform: "translate(66.337 28.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31200",
    "data-name": "Path 31200",
    d: "M-4660.879-6629.277h-.011c0-.011,0-.011-.01-.02h.01C-4660.889-6629.286-4660.879-6629.286-4660.879-6629.277Z",
    transform: "translate(4660.9 6629.296)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31201",
    "data-name": "Path 31201",
    d: "M-4660.293-6628.374a.157.157,0,0,0-.051-.07.24.24,0,0,1-.04-.048.069.069,0,0,0-.021-.042.073.073,0,0,1-.018-.041c0-.008-.011-.028-.011-.04A2.183,2.183,0,0,0-4660.293-6628.374Z",
    transform: "translate(4660.926 6629.334)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31202",
    "data-name": "Path 31202",
    d: "M-4659.831-6627.529c-.011-.01-.011-.02-.021-.029a.714.714,0,0,0-.051-.122A.239.239,0,0,1-4659.831-6627.529Z",
    transform: "translate(4660.957 6629.388)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31203",
    "data-name": "Path 31203",
    d: "M-4659.195-6626.259a.884.884,0,0,0-.04-.105h.008C-4659.216-6626.329-4659.206-6626.288-4659.195-6626.259Z",
    transform: "translate(4660.994 6629.463)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31204",
    "data-name": "Path 31204",
    d: "M-4658-6621.271v-.051c-.01-.088-.01-.179-.021-.259v-.09a3.551,3.551,0,0,1,.04.562c-.01-.049-.01-.09-.02-.139Z",
    transform: "translate(4661.063 6629.729)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31205",
    "data-name": "Path 31205",
    d: "M-4658.461-6616.655l-.06.244v.009c-.06.192-.121.394-.191.593.051-.149.1-.31.141-.462a.574.574,0,0,0,.04-.131C-4658.5-6616.492-4658.482-6616.575-4658.461-6616.655Z",
    transform: "translate(4661.025 6630.014)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31206",
    "data-name": "Path 31206",
    d: "M-4658.349-6617.146c-.009.05-.02.1-.029.151v.01a.011.011,0,0,0-.011.011v-.011C-4658.38-6617.031-4658.359-6617.09-4658.349-6617.146Z",
    transform: "translate(4661.043 6629.987)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31207",
    "data-name": "Path 31207",
    d: "M-4658.141-6618.108a2.793,2.793,0,0,0-.051.29c-.01.071-.029.141-.04.211-.006.029-.013.056-.021.083v.021c-.011.04-.02.071-.032.107v.01a3.068,3.068,0,0,1-.069.3c.04-.2.082-.4.119-.594.03-.139.051-.281.083-.421Z",
    transform: "translate(4661.044 6629.932)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31208",
    "data-name": "Path 31208",
    d: "M-4657.94-6620.333c0,.191-.01.371-.021.56a.02.02,0,0,1,0,.027h0v.153c-.009.105-.009.2-.021.3s-.018.192-.031.283c-.01.107-.021.22-.04.331a.4.4,0,0,0-.01.107c-.011.088-.021.18-.031.27.031.252.051.5.07.754-.02-.232-.05-.471-.082-.7-.011.089-.031.181-.04.261a.032.032,0,0,0-.009.021.07.07,0,0,1,.009-.062c-.009-.011,0-.021,0-.032a.222.222,0,0,0,.01-.068c0-.021.01-.029.01-.051a.121.121,0,0,0,.01-.06v-.153c.041-.22.061-.421.091-.642,0-.028.01-.062.01-.089v-.07c.02-.191.03-.372.04-.563.009-.118.009-.261.009-.371v-.192c0-.23,0-.461-.009-.693A5.228,5.228,0,0,1-4657.94-6620.333Z",
    transform: "translate(4661.056 6629.767)",
    fill: "#0f1c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31209",
    "data-name": "Path 31209",
    d: "M-4612.6-6617.093v.111a1.568,1.568,0,0,1-.029.3A2.935,2.935,0,0,0-4612.6-6617.093Z",
    transform: "translate(4663.641 6629.989)",
    fill: "#0f1c2c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28076",
    "data-name": "Group 28076",
    transform: "translate(66.337 28.916)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31210",
    "data-name": "Path 31210",
    d: "M-4660.879-6629.277v.01l-.011-.01c0-.011,0-.011-.01-.02h.01C-4660.889-6629.286-4660.879-6629.286-4660.879-6629.277Z",
    transform: "translate(4660.9 6629.296)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31211",
    "data-name": "Path 31211",
    d: "M-4660.519-6628.731v.009l-.009-.009a.177.177,0,0,0-.041-.07A.15.15,0,0,1-4660.519-6628.731Z",
    transform: "translate(4660.919 6629.325)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31212",
    "data-name": "Path 31212",
    d: "M-4660.51-6628.727v.011l-.011-.011Z",
    transform: "translate(4660.922 6629.329)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31213",
    "data-name": "Path 31213",
    d: "M-4658.469-6616.655c-.021.081-.04.164-.061.244v.009c-.021.042-.03.091-.049.131a.688.688,0,0,0,.039-.131C-4658.51-6616.492-4658.491-6616.575-4658.469-6616.655Z",
    transform: "translate(4661.031 6630.014)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31214",
    "data-name": "Path 31214",
    d: "M-4658.379-6616.988s-.011,0-.011.009v-.009Z",
    transform: "translate(4661.043 6629.996)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31215",
    "data-name": "Path 31215",
    d: "M-4658.255-6617.541c-.01.04-.02.071-.03.111.01-.029.01-.062.02-.106Z",
    transform: "translate(4661.048 6629.964)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31216",
    "data-name": "Path 31216",
    d: "M-4659.8-6627.475c-.009-.008-.009-.02-.02-.027-.061-.123-.131-.234-.19-.344-.043-.074-.083-.152-.12-.232a.012.012,0,0,1-.011-.01h0c-.05-.09-.1-.168-.149-.249l-.092-.151a.066.066,0,0,0-.02-.042.068.068,0,0,1-.02-.041.084.084,0,0,1-.032-.06l.021.019c.041.083.09.164.141.245.03.04.051.089.082.13a1.765,1.765,0,0,1,.106.171c.081.14.17.291.244.442A.234.234,0,0,1-4659.8-6627.475Z",
    transform: "translate(4660.926 6629.334)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31217",
    "data-name": "Path 31217",
    d: "M-4658.062-6618.7l-.029.271c0,.01-.011.02-.011.031v.021c-.009.089-.029.18-.04.261a.042.042,0,0,0-.01.021.067.067,0,0,1,.01-.06c-.01-.009,0-.021,0-.03a.212.212,0,0,0,.011-.07c0-.021.01-.03.01-.051a.136.136,0,0,0,.011-.06v-.06l.009-.01v-.04a.085.085,0,0,0,.011-.05v-.039a.129.129,0,0,0,.01-.061.04.04,0,0,0,.009-.031A.056.056,0,0,1-4658.062-6618.7Z",
    transform: "translate(4661.056 6629.897)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31218",
    "data-name": "Path 31218",
    d: "M-4658.077-6622.527c-.03-.12-.051-.252-.081-.383l-.031-.16c-.019-.072-.029-.153-.051-.232-.022-.113-.048-.224-.081-.333-.021-.089-.05-.181-.071-.27-.01-.021-.01-.04-.02-.062-.02-.069-.04-.151-.061-.231s-.04-.141-.061-.22l-.009-.011c-.031-.1-.061-.2-.106-.312v-.019a.031.031,0,0,1-.01-.02c-.009-.04-.03-.091-.04-.132a.437.437,0,0,0-.051-.13,1.587,1.587,0,0,0-.081-.231c-.011-.009-.011-.031-.021-.04-.011-.03-.02-.051-.03-.081a.734.734,0,0,0-.05-.141.7.7,0,0,0-.039-.131l-.01-.012c0-.009,0-.009-.011-.009-.039-.105-.081-.2-.12-.3l-.06-.152-.061-.151h-.01v-.009c-.09-.2-.18-.411-.282-.614v-.009l-.009-.01-.151-.3-.15-.3a2.507,2.507,0,0,1,.163.284,9.633,9.633,0,0,1,.432.882c.01.021.02.031.02.051s.009.011.009.02h.01c.009.03.021.071.03.106.082.17.151.351.22.528a7.58,7.58,0,0,1,.272.74c.02.071.04.139.06.2.061.171.106.351.163.522.009.049.03.105.041.151.082.3.163.6.22.9.043.174.079.35.105.528A.135.135,0,0,1-4658.077-6622.527Z",
    transform: "translate(4660.961 6629.396)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31219",
    "data-name": "Path 31219",
    d: "M-4658.121-6622.484a2.6,2.6,0,0,0-.05-.271v-.04a.2.2,0,0,1,.021.106A1.629,1.629,0,0,1-4658.121-6622.484Z",
    transform: "translate(4661.056 6629.666)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31220",
    "data-name": "Path 31220",
    d: "M-4657.995-6621.227v-.051c-.01-.09-.01-.181-.021-.261v-.011c-.021-.19-.04-.372-.061-.559-.009-.042-.009-.083-.018-.131l-.031-.261a.313.313,0,0,1,.021.1c0,.031.011.06.011.091a.119.119,0,0,1,.01.05,1.366,1.366,0,0,1,.02.191c.02.149.041.3.051.441a3.93,3.93,0,0,1,.04.562c-.011-.05-.011-.09-.02-.141Z",
    transform: "translate(4661.058 6629.682)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31221",
    "data-name": "Path 31221",
    d: "M-4657.946-6620.335c0,.189-.011.372-.021.561a.018.018,0,0,1,0,.027h0v.153c-.01.106-.01.2-.021.3s-.019.191-.029.281c-.011.107-.021.22-.042.332.011-.121.019-.231.03-.352,0-.03.01-.061.01-.091v-.068c.021-.191.029-.372.04-.562.009-.12.009-.262.009-.372v-.192c0-.229,0-.461-.009-.691A4.861,4.861,0,0,1-4657.946-6620.335Z",
    transform: "translate(4661.062 6629.767)",
    fill: "#f79d50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28077",
    "data-name": "Group 28077",
    transform: "translate(0.017 13.396)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31222",
    "data-name": "Path 31222",
    d: "M-4657.787-6629.106l-3.325.528-2.671.422-12.144,26.308-45.482-26.265a5.484,5.484,0,0,1-1.366-1.076,3.79,3.79,0,0,1-.317-.391,2.929,2.929,0,0,1-.422-.823,2.767,2.767,0,0,1-.142-.846,3.757,3.757,0,0,1,2.21-3.092l15.746-9.16a76.311,76.311,0,0,1,11.531-.423l-4.419,2.537a1.026,1.026,0,0,0-.643.853v.675c.106-.01.231-.01.353-.01a1.524,1.524,0,0,0,.2.148l.09.052,2.04,1.2,8.679,5.084a3.137,3.137,0,0,0,2.883-.042l4.862-2.782,1.969-1.125h.01a.226.226,0,0,1,.081.021.283.283,0,0,1,.082.019v-.14a1.463,1.463,0,0,0,.244-.179.916.916,0,0,0,.164-.173.025.025,0,0,0,.01-.02,1.512,1.512,0,0,0,.106-.2v-.009a.835.835,0,0,0,.041-.211v-.013a1,1,0,0,0-.553-.813l-6.58-3.846a54.673,54.673,0,0,1,17.743,6.145A29.742,29.742,0,0,1-4657.787-6629.106Z",
    transform: "translate(4723.656 6643.982)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31223",
    "data-name": "Path 31223",
    d: "M-4700.191-6640.061c-.121,0-.244,0-.352.011v-.676a.568.568,0,0,0,.03.181.18.18,0,0,0,.021.082.735.735,0,0,0,.082.163c.009.009.009.02.02.02a.385.385,0,0,0,.105.121A.455.455,0,0,0-4700.191-6640.061Z",
    transform: "translate(4724.968 6644.167)",
    fill: "#f79d50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31224",
    "data-name": "Path 31224",
    d: "M-4680.432-6637.794v.141a.219.219,0,0,0-.082-.021.246.246,0,0,0-.082-.021l.082-.049C-4680.487-6637.761-4680.459-6637.776-4680.432-6637.794Z",
    transform: "translate(4726.102 6644.334)",
    fill: "#f79d50"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28078",
    "data-name": "Group 28078",
    transform: "translate(65.904 28.939)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31225",
    "data-name": "Path 31225",
    d: "M-4660.881-6629.274v.01l-.01-.01Z",
    transform: "translate(4661.333 6629.274)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31226",
    "data-name": "Path 31226",
    d: "M-4660.3-6628.347l-.089-.151a.15.15,0,0,0,.04.049A.438.438,0,0,0-4660.3-6628.347Z",
    transform: "translate(4661.362 6629.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31227",
    "data-name": "Path 31227",
    d: "M-4661.3-6626.036v.083c0-.013,0-.021-.01-.021v-.051Z",
    transform: "translate(4661.31 6629.458)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31228",
    "data-name": "Path 31228",
    d: "M-4658.794-6625.179v.02a1.7,1.7,0,0,0-.082-.232C-4658.844-6625.32-4658.823-6625.25-4658.794-6625.179Z",
    transform: "translate(4661.447 6629.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31229",
    "data-name": "Path 31229",
    d: "M-4658.746-6625.042a.482.482,0,0,0-.049-.128h.01A1.108,1.108,0,0,0-4658.746-6625.042Z",
    transform: "translate(4661.453 6629.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31230",
    "data-name": "Path 31230",
    d: "M-4658.349-6617.144c-.009.049-.02.1-.029.151v.01h-.011C-4658.38-6617.029-4658.359-6617.089-4658.349-6617.144Z",
    transform: "translate(4661.475 6629.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31231",
    "data-name": "Path 31231",
    d: "M-4658.142-6618.109a2.216,2.216,0,0,0-.051.289c-.01.071-.029.14-.04.211-.006.029-.012.056-.021.083v.021l-.011.009c-.011.041-.011.07-.021.1v.013a3.036,3.036,0,0,1-.069.3c.04-.2.083-.4.119-.593.031-.14.051-.282.083-.423Z",
    transform: "translate(4661.477 6629.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31232",
    "data-name": "Path 31232",
    d: "M-4658.14-6618.185v.04a.033.033,0,0,0-.009.021C-4658.163-6618.145-4658.152-6618.164-4658.14-6618.185Z",
    transform: "translate(4661.488 6629.904)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31233",
    "data-name": "Path 31233",
    d: "M-4658.025-6619.134c-.011.119-.02.23-.028.352a.387.387,0,0,0-.011.105.069.069,0,0,0-.011.042.035.035,0,0,1-.009.031.115.115,0,0,1-.01.061v.041a.072.072,0,0,1-.011.05v.04l-.009.011v-.089C-4658.075-6618.712-4658.05-6618.913-4658.025-6619.134Z",
    transform: "translate(4661.491 6629.85)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35260",
    "data-name": "Group 35260",
    transform: "translate(893.321 424.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30061",
    "data-name": "Group 30061",
    transform: "translate(65.147 38.252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30060",
    "data-name": "Group 30060",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30057",
    "data-name": "Group 30057",
    transform: "translate(17.089 31.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33642",
    "data-name": "Path 33642",
    d: "M-6716.868-457.7l7.33,4.233-.1,37.879-7.351,4.264Z",
    transform: "translate(6716.993 457.702)",
    fill: "#121b45"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30058",
    "data-name": "Group 30058",
    transform: "translate(0 4.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33643",
    "data-name": "Path 33643",
    d: "M-6708.839-452.414v.063l-7.33-4.233-.125,46.377-9.863-5.683.135-46.387-7.361-4.244,12.366-17.37,9.52,24.6Z",
    transform: "translate(6733.383 483.892)",
    fill: "#94c1ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33644",
    "data-name": "Path 33644",
    d: "M-6709.811-453.618l-.032-.021v-.063Z",
    transform: "translate(6734.387 485.179)",
    fill: "#94c1ea"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30059",
    "data-name": "Group 30059",
    transform: "translate(12.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33645",
    "data-name": "Path 33645",
    d: "M-6701.962-456.431l-7.351,4.275-.032-.083-2.658-6.882-9.52-24.6,7.34-4.265Z",
    transform: "translate(6721.523 487.982)",
    fill: "#121b45"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30066",
    "data-name": "Group 30066",
    transform: "translate(32.269 19.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30065",
    "data-name": "Group 30065",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30062",
    "data-name": "Group 30062",
    transform: "translate(17.089 31.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33646",
    "data-name": "Path 33646",
    d: "M-6748.4-475.781l7.33,4.233-.1,37.879-7.351,4.264Z",
    transform: "translate(6748.526 475.781)",
    fill: "#121b45"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30063",
    "data-name": "Group 30063",
    transform: "translate(0 4.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33647",
    "data-name": "Path 33647",
    d: "M-6740.372-470.493v.063l-7.33-4.233-.125,46.377-9.863-5.683.135-46.387-7.361-4.244,12.366-17.37,9.52,24.6Z",
    transform: "translate(6764.916 501.97)",
    fill: "#94c1ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33648",
    "data-name": "Path 33648",
    d: "M-6741.344-471.7l-.032-.021v-.063Z",
    transform: "translate(6765.92 503.258)",
    fill: "#94c1ea"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30064",
    "data-name": "Group 30064",
    transform: "translate(12.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33649",
    "data-name": "Path 33649",
    d: "M-6733.5-474.51l-7.351,4.275-.032-.083-2.658-6.882-9.52-24.6,7.34-4.265Z",
    transform: "translate(6753.056 506.061)",
    fill: "#121b45"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30071",
    "data-name": "Group 30071",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30070",
    "data-name": "Group 30070",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30067",
    "data-name": "Group 30067",
    transform: "translate(17.089 31.572)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33650",
    "data-name": "Path 33650",
    d: "M-6779.35-494.389l7.33,4.233-.1,37.879-7.35,4.264Z",
    transform: "translate(6779.475 494.389)",
    fill: "#121b45"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30068",
    "data-name": "Group 30068",
    transform: "translate(0 4.265)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33651",
    "data-name": "Path 33651",
    d: "M-6771.321-489.1v.063l-7.33-4.233-.125,46.377-9.863-5.683.135-46.387-7.361-4.244,12.366-17.37,9.519,24.6Z",
    transform: "translate(6795.865 520.579)",
    fill: "#94c1ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33652",
    "data-name": "Path 33652",
    d: "M-6772.293-490.305l-.031-.021v-.063Z",
    transform: "translate(6796.869 521.866)",
    fill: "#94c1ea"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_30069",
    "data-name": "Group 30069",
    transform: "translate(12.366)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33653",
    "data-name": "Path 33653",
    d: "M-6764.444-493.118l-7.351,4.275-.031-.083-2.659-6.882L-6784-520.4l7.34-4.265Z",
    transform: "translate(6784.005 524.669)",
    fill: "#121b45"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnloadBefore);
export default __webpack_public_path__ + "static/media/unload_before.e81a1e38b1808893184af216fafcfac8.svg";
export { ForwardRef as ReactComponent };